import React, { CSSProperties } from 'react'
import { Form, Input } from 'antd'
import { BaseInputProps } from '../../types/types'
import './InputText.less'

const { TextArea } = Input
export type InputTextProps = {
  onChange?: (e?: React.ChangeEvent<HTMLInputElement>) => void
  layout?: 'column' | 'row'
  type?: string | 'email'
  required?: boolean
  errorMessage?: string
  onBlur?: () => void
  id?: string
  element?: 'textarea' | 'input'
  rows?: number
  wrapperClassName?: string
  style?: CSSProperties
  autoSize?: boolean
  maxLength?: number
  formItemMaxWidth?: number
  asNumberInput?: boolean
  tooltip?: string
  label?: string
} & Omit<BaseInputProps, 'label'>

function InputText({
  label,
  value,
  onChange,
  placeholder,
  element = 'input',
  disabled,
  layout = 'row',
  rows = 1,
  type,
  required,
  errorMessage,
  onBlur,
  id,
  wrapperClassName,
  style,
  autoSize,
  maxLength = 1000,
  formItemMaxWidth,
  asNumberInput = false,
  tooltip,
  ...props
}: InputTextProps) {
  return (
    <div id={type === 'email' ? 'email' : ''}>
      <Form.Item
        tooltip={tooltip}
        style={{ maxWidth: formItemMaxWidth || 'inherit' }}
        name={type}
        label={label}
        rules={[
          {
            required,
            ...(type === 'email' && { type }),
            ...(errorMessage && { message: errorMessage }),
          },
        ]}
        labelCol={layout === 'column' ? { span: 24 } : {}}
        wrapperCol={layout === 'column' ? { span: 24 } : {}}
        className={wrapperClassName}
      >
        {element === 'input' ? (
          <Input
            id={id}
            placeholder={placeholder as string}
            value={value as string}
            onChange={onChange}
            disabled={disabled}
            onBlur={onBlur}
            {...props}
            style={style}
            maxLength={maxLength}
            // @ts-ignore
            type={asNumberInput && 'number'}
            min={asNumberInput ? 0 : undefined}
          />
        ) : (
          <TextArea
            id={id}
            placeholder={placeholder as string}
            value={value as string}
            onChange={onChange}
            disabled={disabled}
            onBlur={onBlur}
            rows={rows}
            {...props}
            style={style}
            autoSize={autoSize}
            maxLength={maxLength}
          />
        )}
      </Form.Item>
    </div>
  )
}

export default InputText
